module.exports = __webpack_public_path__ + "img/89.ff7abf37.jpg";